import { render } from "./Header.vue?vue&type=template&id=d2a73a4c&scoped=true"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import "./Header.vue?vue&type=style&index=0&id=d2a73a4c&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\mm\\Documents\\__Kundenprojekte\\ÜIM-HAB\\Entwicklung\\Frontend\\uebersetzen\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d2a73a4c"]])

export default __exports__